import React from 'react';
import { connect } from 'react-redux';
import Card from '../Card/Card';
import { FormattedMessage } from 'react-intl';
import { Alert } from 'reactstrap';
import ChangePasswordForm from './ChangePasswordForm';
import { startChangePassword } from '../../actions/webmaster';
import { endOtherSessions } from '../../actions/webmaster';

class ChangePasswordBlock extends React.Component {
  state = {
    loading: false,
    success: false,
    msg: null,
  };

  onSubmit = (passwords, form) => {
    this.setState(() => ({ loading: true }));

    return this.props.startChangePassword(passwords).then((result) => {
      const { error = '' } = result;

      let msg = null;

      if (error && error.message) {
        msg = error.message;
        this.setState(() => ({ success: false }));
      } else {
        msg = <FormattedMessage id="password.changed-password" defaultMessage="Password changed" />;

        this.setState(() => ({ success: true }));
      }

      this.setState(() => ({
        loading: false,
        msg,
      }));
    });
  };

  endOtherSessions = () => {
    this.setState(() => ({ loading: true }));

    return this.props.endOtherSessions().then((result) => {
      const { error = '' } = result;

      let msg = null;
      let message = result.result?.message;

      if (error && error.message) {
        msg = error.message;
        this.setState(() => ({ success: false }));
      } else {
        let suffix = message ? '.' + message : '';
        msg = (
          <FormattedMessage
            id={`password.sessions.ended${suffix}`}
            defaultMessage="Other active sessions have ended"
          />
        );

        this.setState(() => ({ success: true }));
      }

      this.setState(() => ({
        loading: false,
        msg,
      }));
    });
  };

  render() {
    const { loading, msg, success } = this.state;
    const alertColor = success ? 'success' : 'danger';

    return (
      // <Card loading={loading}>
      <>
        {/* <Card.Header>
          <FormattedMessage id="password.title" defaultMessage="Password" />
        </Card.Header> */}
        {/* <Card.Body> */}
        {msg && <Alert color={alertColor}>{msg}</Alert>}
        <ChangePasswordForm onSubmit={this.onSubmit} endOtherSessions={this.endOtherSessions} />
        {/* </Card.Body> */}
      </>
      // </Card>
    );
  }
}

const mapDispatchToProps = {
  startChangePassword,
  endOtherSessions,
};

export default connect(null, mapDispatchToProps)(ChangePasswordBlock);
